import { CommonKeys, FormularModelKeys } from "./common/enums";
import { Injectable, inject } from "@angular/core";
import { FormularValidatorAjvProviderService } from "./formular-model-validator.service";
import { FormularMeta } from "./formular-groups/interfaces/formular-meta/FormularMeta";
import { FormularGroup } from "./formular-groups/interfaces/FormularGroup";
import { FORMULAR_GROUP_SCHEMAS } from "./formular-groups/validation-schemas/FormularGroup";
import { FORMULAR_META_SCHEMAS } from "./formular-groups/validation-schemas/formular-meta/FormularMeta";
import { FORMULAR_TYPE } from "./common/formular-group-types";
import cloneDeep from 'lodash/cloneDeep';

export const FormularModelSchema = {
    $id: "FormularModelSchema",
    title: "FormularModel Schema",
    type: "object",
    properties: {
        [CommonKeys.Type]: { const: FORMULAR_TYPE },
        [FormularModelKeys.VID]: { type: "string" },
        [FormularModelKeys.FID]: { type: "string" },
        [FormularModelKeys.Bezeichnung]: { type: "string" },
        [FormularModelKeys.Meta]: { $ref: "FormularModelMetaSchema" },
        [FormularModelKeys.Groups]: { $ref: "FormularModelGroupsSchema" }
    },
    required: [CommonKeys.Type, ...Object.values(FormularModelKeys)]
}

export const FORMULAR_SCHEMAS = [
    FormularModelSchema,
    ...FORMULAR_GROUP_SCHEMAS,
    ...FORMULAR_META_SCHEMAS,
]


@Injectable({ providedIn: 'root' })
export class FormularModelValidator {
    private _ajv = inject(FormularValidatorAjvProviderService);


    private _validate: any;

    constructor() {
        this._ajv.addSchema(FORMULAR_SCHEMAS);

        this._validate = this._ajv.getSchema('FormularModelSchema');

        if (!this._validate) {
            console.error("Ajv validator for FormularModel not found");
        }
    }

    public validate(data: any): data is FormularModel {
        if (!this._validate) {
            return false;
        }

        const isValid = this._validate(data);

        if (!isValid) {
            console.error("Validation errors in FormularModel:", this._validate.errors);
            return false;
        }

        return true;
    }
}



export interface FormularModel {
    [CommonKeys.Type]: string,
    [FormularModelKeys.VID]: string,
    [FormularModelKeys.FID]: string,
    [FormularModelKeys.Bezeichnung]: string,
    [FormularModelKeys.Meta]?: FormularMeta,
    [FormularModelKeys.Groups]?: FormularGroup[]
}

export function assertFormularModel(data: object): FormularModel {
    return cloneDeep(data) as FormularModel;
}

